var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_wind_barb_style_interface = function () {
    OCS.Viewer.Interfaces.OlWindBarbStyle = {
        options: {
            layer_style_ops: {},
            wind_barb_style_type_text: 'wind_barb',
            wind_barb_style_ops: {
                image: {
                    scale: 1,
                    rotateWithView: false,
                    rotation: 0,
                    rotation_offset: 0,
                    anchor: [0.73914, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    size: [69, 38],
                    offsetOrigin: 'top-left',
                    offset: [0, 38], // Set to a basis of 1 x 1 so that it can be multiplied by the value
                    src: 'dist/images/wind_barbs_sprite_black.png',
                    type: 'Icon'
                }
            }
        },

        get_wind_barb_layer_style_method: function (in_feature, res) {
            var feature;
            var features = in_feature.get('features');
            if (features && features.length) {
                feature = in_feature.get('active_feature');
                if (!feature) {
                    feature = features[0];
                }
            } else {
                feature = in_feature;
            }

            var value = feature.get('wspd');
            var direction = feature.get('wdir');

            if (value === null || direction === null || value === '' || direction === '') {
                //var style_ops = {};
                return [];
            }

            value = Math.round(value / 5);
            direction = (direction * Math.PI / 180) + this.get_wind_barb_rotation_offset();
            var offset = this.get_wind_barb_value_offset(value);

            if (!value) {
                direction = 0; // If we have no wind speed than no need to show a direction.
            }
            var style = this.get_style_with_ops(this.build_style_ops(this.set_style_ops(this.options.wind_barb_style_ops, {'image': {'rotation': direction, 'offset': offset}})));
            return [style];
        },
        get_wind_barb_rotation_offset: function () {
            var ops = OCS.Viewer.Functions.get_utilities().clone_object(this.options.wind_barb_style_ops, this.options.style_prop_keys);
            return ops.image.rotation_offset + (Math.PI / 2);
        },
        get_wind_barb_value_offset: function (value) {
            var ops = OCS.Viewer.Functions.get_utilities().clone_object(this.options.wind_barb_style_ops, this.options.style_prop_keys);
            return [ops.image.offset[0] * value, ops.image.offset[1] * value];
        }
    }; // End OCS.Viewer.Interfaces.OlWindBarbStyle
};
OCS.Viewer.Functions.define_ol_wind_barb_style_interface();